import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  DialogActions,
  Button,
} from '@mui/material';
import Modal from '../../components/Modal';

export default function ConfirmationModal({
  open,
  onConfirm,
  onClose,
  children,
  title,
}) {
  return (
    <Modal isOpen={open} handleClose={onClose} title={title}>
      <Box>
        {children}
        <DialogActions>
          <Button onClick={onConfirm} variant="contained" sx={{ mr: 1 }}>Confirm</Button>
          <Button onClick={onClose}>Cancel</Button>
        </DialogActions>
      </Box>
    </Modal>
  );
}

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
};

ConfirmationModal.defaultProps = {
  title: '',
};
